// extracted by css-extract-rspack-plugin
export default {"root":"np1uBkwp4eFm0kYO","content":"jUGsBJCbA3c0AwZx","skipLink":"AGI8amZt4Nk0YmpD"};